import { createContext, useContext, useReducer } from "react";
import { reducer, initialState } from "../reducers/reducer.jsx";
const UserDataContext = createContext();

function ContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <UserDataContext.Provider value={{ state, dispatch }}>
      {children}
    </UserDataContext.Provider>
  );
}

function useData() {
  return useContext(UserDataContext);
}

export { ContextProvider, useData };
